import React, { FC, useCallback, memo } from 'react';
import { useFormikContext } from 'formik';
import _forEach from 'lodash/forEach';
import FormikUncontrolledRadioGroup from '@minecraft.formik-uncontrolled-radio-group';
import { useDrawerSearchFilterNameOrCategory } from '@minecraft.drawer';
import { FilterData, Label, FilterDrawerType } from '@blocs.filter';
import { initialFilters, clearableSizesRangeFilters } from '../../../shared/config';
import { FiltersCategoryNameEnum } from '../../../shared/types';

type Props = {
  type: FilterDrawerType;
} & FilterData;

const ClothingSizesCategory: FC<Props> = ({ type, name, label }) => {
  const { values, setFieldValue } = useFormikContext();
  const { getMatchedSearchOptions } = useDrawerSearchFilterNameOrCategory(FiltersCategoryNameEnum.clothingSizes);

  const handleChange = useCallback((): void => {
    _forEach(clearableSizesRangeFilters, (filter) => {
      setFieldValue(filter, initialFilters[type][filter], false);
    });
  }, [values[name]]);

  return (
    <>
      <Label>{label}</Label>
      <FormikUncontrolledRadioGroup
        saveAsOption
        enableReinitializeDefaultValue
        defaultValue={values[name]}
        name={name}
        options={getMatchedSearchOptions(name)}
        handleChange={handleChange}
      />
    </>
  );
};

export default memo(ClothingSizesCategory);
